<template>
  <div class="rp-page product-profit">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="box-seam-fill" class="mr-2"></b-icon>Mahsulot foyda zarari</h2>
        </div>
        <button class="rp-btn rp-btn-secondary" @click="exportCsv" :disabled="loading || items.length === 0">
          <b-icon icon="file-earmark-excel"></b-icon> Excel
        </button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter"><label>Qidiruv</label><input type="search" v-model="search" placeholder="Mahsulot..."></div>
        <div class="rp-filter"><label>&nbsp;</label><button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button></div>
      </div>

      <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
      <div class="rp-summary rp-summary-6">
        <div class="rp-card rp-c-1"><div class="rp-card-label">MAHSULOT TURI</div><div class="rp-card-value">{{ filtered.length }}</div></div>
        <div class="rp-card rp-c-2"><div class="rp-card-label">JAMI SOTUV</div><div class="rp-card-value rp-green">{{ fmt(totals.total_sales) }}</div></div>
        <div class="rp-card rp-c-1"><div class="rp-card-label">NASIYASIZ SOTUV</div><div class="rp-card-value rp-green">{{ fmt(totals.paid_sales) }}</div><div class="rp-card-sub">Savdo paytidagi holat</div></div>
        <div class="rp-card rp-c-3"><div class="rp-card-label">NASIYA SOTUV</div><div class="rp-card-value">{{ fmt(totals.credit_sales) }}</div><div class="rp-card-sub">Savdo paytidagi holat</div></div>
        <div class="rp-card rp-c-3"><div class="rp-card-label">JAMI TANNARX</div><div class="rp-card-value rp-red">{{ fmt(totals.total_cost) }}</div></div>
        <div class="rp-card rp-c-4">
          <div class="rp-card-label">SOF FOYDA ({{ marginPercent }}%)</div>
          <div class="rp-card-value" :class="totals.total_profit >= 0 ? 'rp-green' : 'rp-red'">{{ fmt(totals.total_profit) }}</div>
        </div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title"><b-icon icon="list-ul"></b-icon> Mahsulotlar bo'yicha (TOP 500)</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>#</th><th>Mahsulot</th>
                <th class="t-center">Soni</th>
                <th class="t-right">Sotuv</th>
                <th class="t-right">Nasiyasiz sotuv</th>
                <th class="t-right">Nasiya sotuv</th>
                <th v-if="hasOtherSales" class="t-right">Qaytarish / boshqa</th>
                <th class="t-right">Tannarx</th>
                <th class="t-right">Foyda</th>
                <th class="t-center">Marja %</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in filtered" :key="r.product_id">
                <td><span class="rp-num">{{ i + 1 }}</span></td>
                <td class="rp-strong">{{ r.product_name || r.short_name }}</td>
                <td class="t-center"><span class="rp-badge rp-badge-blue">{{ fmt(r.total_count) }}</span></td>
                <td class="t-right">{{ fmt(r.total_sales) }}</td>
                <td class="t-right rp-green">{{ fmt(r.paid_sales) }}</td>
                <td class="t-right">{{ fmt(r.credit_sales) }}</td>
                <td v-if="hasOtherSales" class="t-right">{{ fmt(r.other_sales) }}</td>
                <td class="t-right rp-red">{{ fmt(r.total_cost) }}</td>
                <td class="t-right rp-strong" :class="r.total_profit >= 0 ? 'rp-green' : 'rp-red'">{{ fmt(r.total_profit) }}</td>
                <td class="t-center"><span class="rp-badge" :class="margin(r) >= 0 ? 'rp-badge-green' : 'rp-badge-red'">{{ margin(r).toFixed(1) }}%</span></td>
              </tr>
              <tr v-if="loading"><td :colspan="hasOtherSales ? 10 : 9" class="rp-empty">Yuklanmoqda...</td></tr>
              <tr v-else-if="filtered.length === 0"><td :colspan="hasOtherSales ? 10 : 9" class="rp-empty">Ma'lumot yo'q</td></tr>
            </tbody>
            <tfoot v-if="filtered.length > 0">
              <tr>
                <th colspan="3" class="t-right">JAMI:</th>
                <th class="t-right">{{ fmt(totals.total_sales) }}</th>
                <th class="t-right">{{ fmt(totals.paid_sales) }}</th>
                <th class="t-right">{{ fmt(totals.credit_sales) }}</th>
                <th v-if="hasOtherSales" class="t-right">{{ fmt(totals.other_sales) }}</th>
                <th class="t-right">{{ fmt(totals.total_cost) }}</th>
                <th class="t-right">{{ fmt(totals.total_profit) }}</th>
                <th class="t-center">{{ marginPercent }}%</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
const emptyTotals = () => ({ total_count: 0, total_sales: 0, paid_sales: 0, credit_sales: 0, other_sales: 0, total_cost: 0, total_profit: 0 });
export default {
  data() {
    const today = new Date(); const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first), date2: this.ds(today),
      sklad_id: null, skladList: [], items: [],
      totals: emptyTotals(),
      search: '', loading: false, error: '', requestId: 0,
    };
  },
  computed: {
    hasOtherSales() { return this.items.some(r => Number(r.other_sales)); },
    filtered() {
      if (!this.search || this.search.length < 2) return this.items;
      const q = this.search.toLowerCase();
      return this.items.filter(r => (r.product_name && r.product_name.toLowerCase().includes(q)) || (r.short_name && r.short_name.toLowerCase().includes(q)));
    },
    marginPercent() {
      if (!this.totals.total_sales) return 0;
      return ((this.totals.total_profit / this.totals.total_sales) * 100).toFixed(2);
    }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, e = false) { return Math.floor(new Date(s + (e ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    margin(r) { const s = parseFloat(r.total_sales)||0; if (s === 0) return 0; return ((parseFloat(r.total_profit)||0) / s) * 100; },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) {} },
    async fetch() {
      const requestId = ++this.requestId;
      this.loading = true;
      this.error = '';
      this.items = [];
      this.totals = emptyTotals();
      try {
        const r = await axios.post('api/v1/report/product-profit/', {
          datetime1: this.toUnix(this.date1), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        if (requestId !== this.requestId) return;
        this.items = r.data.items || [];
        this.totals = { ...emptyTotals(), ...r.data.totals };
      } catch (e) {
        if (requestId === this.requestId) this.error = "Hisobotni yuklab bo'lmadi. Qayta urinib ko'ring.";
        console.error(e);
      }
      finally { if (requestId === this.requestId) this.loading = false; }
    },
    exportCsv() {
      const h = ['Mahsulot', 'Soni', 'Sotuv', 'Nasiyasiz sotuv', 'Nasiya sotuv', 'Qaytarish / boshqa', 'Tannarx', 'Foyda', 'Marja%'];
      const rows = this.filtered.map(r => [r.product_name||r.short_name, r.total_count, r.total_sales, r.paid_sales, r.credit_sales, r.other_sales, r.total_cost, r.total_profit, this.margin(r).toFixed(2)]);
      const csv = [h, ...rows].map(x => x.map(c => `"${String(c == null ? '' : c).replace(/"/g,'""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿"+csv], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `mahsulot_foyda_${this.date1}_${this.date2}.csv`; a.click(); URL.revokeObjectURL(a.href);
    }
  }
};
</script>

<style scoped>
.product-profit .rp-summary-6 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.product-profit .rp-card-value { overflow-wrap: anywhere; }
.product-profit .rp-card-sub { margin-top: 4px; font-size: 12px; color: #64748b; }
.product-profit .rp-back { flex-shrink: 0; }
.product-profit .rp-table { min-width: 1100px; }
@media (max-width: 768px) {
  .product-profit .rp-summary-6 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .product-profit .rp-filters { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .product-profit .rp-filter { min-width: 0; }
  .product-profit .rp-filter input, .product-profit .rp-filter select { width: 100%; min-width: 0; }
  .product-profit .rp-filter-grow { grid-column: 1 / -1; }
}
</style>
